import { formatErrorDetail } from '../../../shared/api/apiError';

const FALLBACK_MESSAGE = 'Failed to export chat to PDF.';

// With responseType 'blob' an error body arrives as a Blob, so the JSON
// `detail` has to be read out of it first.
const readBlobDetail = async blob => {
	try {
		return JSON.parse(await blob.text()).detail;
	} catch {
		return undefined;
	}
};

export const getExportErrorMessage = async error => {
	const data = error.response?.data;
	const detail = data instanceof Blob ? await readBlobDetail(data) : data?.detail;

	if (detail) return formatErrorDetail(detail, FALLBACK_MESSAGE);
	if (data instanceof Blob) return FALLBACK_MESSAGE;
	return error.message || FALLBACK_MESSAGE;
};
